<div class="w-full md:w-[750px]">
    <h2 class="text-[30px] text-black font-medium w-full text-center">Forgot your password?</h2>

    @if (emailSent) {
        <p class="w-full text-center text-[#4A4A4A] text-[20px] mt-4">
            An email with instructions on how to reset your password has been sent to the email address you entered.
        </p>
        <button pButton type="button"
                class="p-button-info rounded-lg w-full mt-4 flex items-center justify-center gap-2 relative"
                [rounded]="true"
                (click)="closeModal()">
            <fa-icon [icon]="icons.faUser" class="absolute left-3"></fa-icon>
            <span class="flex-1 text-center font-medium text-sm md:text-base">Close</span>
        </button>
    } @else {
        <p class="w-full text-center text-[#4A4A4A] text-[20px] mt-4">
            Don't worry, we will send you reset instructions
        </p>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-3 md:gap-4 mt-4">
            <div>
                <label for="email" class="block text-[16px] font-medium text-[#4A4A4A]">Email</label>
                <input  id="email" type="email" formControlName="email"
                        class="p-inputtext p-component w-full mt-1 border rounded-md px-3 py-2 text-sm"
                        [ngClass]="{ 'p-invalid': email.invalid }" placeholder="Email address" />
                <small class="text-red-500 text-xs md:text-sm" *ngIf="email.dirty && email.invalid">
                    Invalid email
                </small>
            </div>

            <button pButton type="submit"
                    class="p-button-info rounded-lg w-full mt-4 flex items-center justify-center gap-2 relative"
                    [rounded]="true"
                    [disabled]="forgotPasswordForm.invalid">
                <fa-icon [icon]="icons.faLock" class="absolute left-3"></fa-icon>
                <span class="flex-1 text-center font-medium text-sm md:text-base">Reset password</span>
            </button>
        </form>
    }
</div>